<template>
  <div class="sp_meeting_widget_container">
    <iframe class="sp_meeting_widget" ref="iframe" :src="resolvedLink"></iframe>
  </div>
</template>

<script>
export default {
  name: 'MeetingWidgetLink',
  props: {
    link: {
      type: String,
      required: true,
    },
    onSuccess: {
      type: Function,
      required: false,
    },
  },
  computed: {
    resolvedLink() {
      if (this.isHubspot(this.link) && !this.link.includes('embed=true')) {
        const separator = this.link.includes('?') ? '&' : '?';
        return `${this.link}${separator}embed=true`;
      }
      return this.link;
    },
  },
  destroyed() {
    window.removeEventListener('message', this.handleMessage);
  },
  mounted() {
    window.addEventListener('message', this.handleMessage);
  },
  methods: {
    handleMessage(event) {
      const origin = event.origin;
      const data = event.data;

      if (this.isHubspot(origin)) {
        if (data && data.meetingBookSucceeded) {
          setTimeout(() => {
            const booking = data.meetingsPayload?.bookingResponse;
            const contact = booking?.postResponse?.contact;
            const event = booking?.event;

            const dateObj = event?.dateTime ? new Date(event.dateTime) : null;

            this.$emit('onSuccess', {
              dateTime: dateObj,
              dateTimeUtc: dateObj ? dateObj.toUTCString() : null,
              contact: {
                firstName: contact?.firstName ?? null,
                lastName: contact?.lastName ?? null,
                name: contact?.name ?? null,
                email: contact?.email ?? null,
              },
            });
          }, 2000);
        }
      }
      if (this.isCalendly(origin)) {
        if (data && data.event === 'calendly.event_scheduled') {
          this.$emit('onSuccess', data);
        }
      }
    },
    isHubspot(value) {
      return /hubspot\.com/.test(value);
    },
    isCalendly(value) {
      return /calendly\.com/.test(value);
    },
    isGoogleMeet(value) {
      return /google\.com/.test(value);
    },
    isZoom(value) {
      return /zoom\.us/.test(value);
    },
  },
}
</script>

<style>
.sp_meeting_widget_container{
  width: 100%;
  height: 100%;
}
.sp_meeting_widget {
  width: 100%;
  height: 100%;
  border: none;
}
</style>


